import { styled } from "@material-ui/core"

export const PortalHeader = styled("header")(({ theme }) => ({
    display: "grid",
    gridAutoFlow: "column",
    gridGap: theme.spacing(2),
    gridAutoColumns: "max-content",
    alignItems: "center",
}))
